<template>
    <div class="page bg-tc-blue-1 relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-8">
            <TopBar class="hidden sm:block" :modalController="modalController"></TopBar>
            <TopBarBack routeBack="/mission" class="block sm:hidden"></TopBarBack>
            <MenuDesktop activeMenu="none"></MenuDesktop>
            <div class="mx-auto page mt-2 sm:pb-0 bg-a-gray-e9ecf5 sm:bg-tc-blue-1">
                <div class="h-2px bg-white sm:hidden"></div>
                <div class="bg-white sm:px-5 sm:py-6 sm:mt-4 sm:p-0 rounded-25 mx-4 mt-4">
                    <PathLink :pathLink1="pathLink"></PathLink>
                    <div class="pt-4">
                        <div class="text-center text-tc-blue-1 text-32">Check in Get Point</div>
                        <div class="text-center text-tc-gray-3 text-20">เช็คอินเพื่อรับคะแนนเพิ่ม!</div>
                        <div class="py-4">
                            <CheckinPointMobile ref="check-mission-mobile"></CheckinPointMobile>
                            <CheckinPointDesktop ref="check-mission-desktop"></CheckinPointDesktop>
                        </div>
                        <div class="hidden sm:flex w-48 mx-auto">
                            <BlueButton @click="clickCheckIn()" :isDisabled="isDisabledBtn">{{ isDisabledBtn ? lbl.getfriend.checkedin : lbl.getfriend.checkin}}</BlueButton>
                        </div>
                    </div>
                    <div v-if="isLoaded">
                        <div class="sm:hidden min-h-50vh pb-24 p-5">
                            <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                        </div>
                        <div class="hidden sm:block mb-5 p-5">
                            <DetailAndCondition :campaign="campaign"></DetailAndCondition>
                        </div>
                        <div class="block sm:hidden footer-mobile-witdh fixed left-0 bottom-0 bg-white text-center mx-16px px-14px py-5 rounded-b-25">
                            <BlueButton @click="clickCheckIn()" :isDisabled="isDisabledBtn">{{ isDisabledBtn ? lbl.getfriend.checkedin : lbl.getfriend.checkin }}</BlueButton>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>
<script>
//helper
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import DetailAndCondition from '@/module/Detail/component/DetailAndCondition.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import BlueButton from '@/components/Button/BlueBtn.vue';
import CheckinPointMobile from '../component/CheckinPointMobile.vue';
import CheckinPointDesktop from '../component/CheckinPointDesktop.vue';
import PathLink from '../component/PathLink.vue'
//mixin
import ModalMixin from '@/mixin/ModalMixin.js';
import AuthStatusMixin from '@/mixin/AuthStatusMixin.js';
import LocaleMixin from '@/mixin/LocaleMixin'

import MissionService from '../service/MissionService';
import Account from '@/helper/AccountHelper'
export default {
    name: "Checkin",
    mixins: [ModalMixin, AuthStatusMixin,LocaleMixin],
    components: {
        TopBar,
        DetailAndCondition,
        MenuDesktop,
        BottomBar,
        TopBarBack,
        BlueButton,
        CheckinPointMobile,
        CheckinPointDesktop,
        PathLink
    },
    data: function() {
        return {
           campaign: {
            detail: '',
            condition: ''
           },
           isDisabledBtn: false,
           mission: null,
           dayOfWeek: null,
           realDayOfWeek: null,
           isLoaded: false,
           pathLink: {
                name: 'Check in Get Point',
                url: ''
            }
        };
    },
    created: async function(){
        this.getCacheUser();
    },
    mounted: async function(){
        this.modalController.loadingModal.show();
        await this.getHistoryCheckin();
        this.modalController.loadingModal.hide();
    },
    methods: {
        getDayOfWeek: function(){
            const date = new Date();
            const daysOfWeek = ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'];
            return daysOfWeek[date.getDay()];
        },
        getCacheUser: function(){
            if(Account.getCacheUser()){
                this.dayOfWeek = Account.getCacheUser().detail.DayOfWeek
                this.realDayOfWeek = this.getDayOfWeek()
                //console.log("dayOfWeek", this.dayOfWeek) 
            }
        },
        clickCheckIn: async function(){
            //console.log("clickCheckIn isDisabledBtn", this.isDisabledBtn)
            if (this.isDisabledBtn) return;
            this.modalController.loadingModal.show();
            await this.postMissionCheckin();
            await this.getHistoryCheckin();
            this.modalController.loadingModal.hide();
        },
        postMissionCheckin: function(){
            return new Promise((resolve) => {
                MissionService.postMissionCheckin()
                    .subscribe({
                        next: (res) => {
                            console.log(res);
                            this.modalController.successModal
                                .setTitle(this.lbl.getfriend.checkin_success)
                                .show();
                            this.getHistoryCheckin();
                            this.isDisabledBtn = true
                        },
                        error: (err) => {
                            resolve(false);
                            this.errorApi(err);
                        }
                    })
            })
        },
        getHistoryCheckin: function() {
            var key = this.$route.params.key;
            this.modalController.loadingModal.show();
            this.isLoaded = false;
            return new Promise((resolve) => {
                MissionService.getMissionCheckin(key)
                    .subscribe ({
                        next: (mission) => {
                            if(mission && mission.length){
                                console.log(mission[0])
                                this.mission = mission[0].missions;
                                this.campaign.detail = mission[0].description;
                                this.campaign.condition = mission[0].condition;
                                let missionCheckin = this.mission.filter(item => item.IsCompleted == true)
                                let checkmissionCheckinToday = missionCheckin.some(item => item.Name == this.dayOfWeek || item.Name == this.realDayOfWeek)
                                if(checkmissionCheckinToday){
                                    this.isDisabledBtn = true
                                }
                                this.$refs['check-mission-desktop'].validateCheckin(this.mission)
                                this.$refs['check-mission-mobile'].validateCheckin(this.mission)
                                this.modalController.loadingModal.hide();
                                this.isLoaded = true;
                                resolve(true);
                            }
                        },
                        error: (err) => {
                            this.isLoaded = true;
                            this.modalController.loadingModal.hide();
                            this.errorApi(err);
                            resolve(false);
                        }
                    })
            });
        },
    }
}
</script>
<style lang="scss" scoped>
.logo-powerby {
    width: 166px;
}
.footer-mobile-witdh {
   width: calc(100% - 32px) ;
}
.contents-height{
    min-height: calc(50vh);
}
</style>
